import React from 'react';
import { Carousel, Container } from 'react-bootstrap';
import Placeholder from '../../Assets/placeholder.jpg';

const PropertyImagesCarousal = ({ images, onImageClick, name, isDetail, address }) => {
    if (!images) {
        return null
    }
    if (images.length < 1) {
        return (
            <div className="propnx-carousel ">
                <img
                    onClick={onImageClick}
                    className="d-block w-100"
                    src={Placeholder}
                    alt="First slide"
                />

                {isDetail && (
                    <Container>
                        <Carousel.Caption>
                            <h1 className='nunitoFont text-light'>{name}</h1>
                            <p>{address}</p>
                        </Carousel.Caption>
                    </Container>
                )}
            </div>
        )
    }
    if (images.length === 1) {
        return (
            <div className="propnx-carousel position-relative">
                <img
                    onClick={onImageClick}
                    className="d-block w-100"
                    src={images[0]}
                    alt="First slide"
                    onError={(event) => {
                        event.target.src = Placeholder
                    }}
                />

                {isDetail && (
                    <Container>
                        <Carousel.Caption>
                            <h1 className='nunitoFont text-light'>{name}</h1>
                            <p>{address}</p>
                        </Carousel.Caption>
                    </Container>
                )}
            </div>
        )
    }
    return <>

        <Carousel className='propnx-carousel' interval={null} variant="light">
            {
                React.Children.toArray(
                    images.map((image) => {
                        if (!image) {
                            return;
                        }
                        return (
                            <Carousel.Item>
                                <img
                                    onClick={onImageClick}
                                    className="d-block w-100"
                                    src={image}
                                    alt="First slide"
                                    onError={(event) => {
                                        event.target.src = Placeholder
                                    }}
                                />
                                {
                                    name
                                        ?
                                        <Container>
                                            <Carousel.Caption>
                                                <h1 className='nunitoFont text-light'>{name}</h1>
                                                <p>{address}</p>
                                            </Carousel.Caption>
                                        </Container>
                                        :
                                        ''
                                }
                            </Carousel.Item>

                        )
                    })
                )
            }
        </Carousel>


    </>;
};

export default PropertyImagesCarousal;
